<template>
  <div style="background-color: #fafafa;">
    <van-nav-bar
      title="货品分布详情"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :z-index="998"
      fixed
    />
    <div class="psiConfirmCont">
      <div>
        <table>
          <tr>
            <td>
              <p>
                <span>商品编码：{{ skuInfo.skuCode }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>商品名称：{{ skuInfo.skuName }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>商品类别：{{ skuInfo.skuCategory }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>商品单位：{{ skuInfo.skuUnitname }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>指导价格：{{ skuInfo.skuPrice }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>库存数量：{{ skuInfo.amount }}</span>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <span>可用库存数量：{{ skuInfo.availableBalance }}</span>
              </p>
            </td>
          </tr>
        </table>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          finished-text="没有更多了"
        >
          <table class="layout">
            <div v-for="tranData in list" class="card" :key="tranData.uuid">
              <tr>
                <td colspan="1">
                  <span>仓库名称：{{ tranData.warehouseIdname || "无" }}</span>
                </td>
                <td colspan="1">
                  <span>货位名称：{{ tranData.binName || "无" }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <span>库存数量：{{ tranData.warehouseAmount || "0" }}</span>
                </td>
                <td colspan="1">
                  <span>可用库存：{{ tranData.quantity || "0" }}</span>
                </td>
              </tr>
            </div>
          </table>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Panel,
  Button,
  List,
  Search,
  Popup,
  PullRefresh,
  // Toast,
  NavBar,
  Tag,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  DatetimePicker,
  Field,
  DropdownMenu,
  DropdownItem,
  Icon,
} from "vant";
import userInfo from "../../store/userInfo";
import inventoryBalanceService from "../../service/electronicInventoryBalanceService";
import moment from "moment";
import { formatDictionary } from "../../utils/dictionary";
import { API_URL } from "../../common/config";

export default {
  data: function() {
    return {
      warehouseId: "",
      warehouseShowName: "",
      detailShow: false,
      selected: 0,
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      value: "",
      refreshing: false,
      type: 0,
      skuInfoStr: "",
      showTime: true,
      activeKey: 0,
      createTime: "",
      currDateType: 0,
      currCreateDateType: 0,
      currDisAdvisorDateType: 0,
      skuInfo: {},
    };
  },
  store: userInfo,
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    },
  },
  created: async function() {
    let tabIndex = localStorage.getItem("allocationDataTabIndex");
    if (tabIndex === undefined || tabIndex === null) {
      tabIndex = 0;
      this.selected = 0;
      this.type = 0;
    } else {
      this.selected = parseInt(tabIndex);
      this.type = parseInt(tabIndex);
    }
  },
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await inventoryBalanceService.getDetailList(
        this.pageIndex,
        this.$route.params.warehouseId,
        this.$route.params.skuCode
      );
      if (resp.data.Status == "1" && resp.data.Data.data.length > 0) {
        resp.data.Data.data.forEach((item) => {
          item.createTime = moment(item.createTime).format("YYYY-MM-DD");
        });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
        this.skuInfo = resp.data.Data.data[0];
      }

      let detailData = [];
      let resp1 = await inventoryBalanceService.getBinAndQuantity(
          this.pageIndex,
          this.$route.params.warehouseId,
          this.skuInfo.sku
        );
        if (resp1.data.Status == "1" && resp1.data.Data.data.length > 0) {
          resp1.data.Data.data.forEach((item) => {
            item.createTime = moment(item.createTime).format("YYYY-MM-DD");
          });
          formatDictionary(resp1.data.Data.data, resp1.data.Data.dictionary);
          detailData = resp1.data.Data.data;
        }
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...detailData];
      this.finished = resp1.data.Data.total <= this.list.length;
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.dropdownItem > .van-dropdown-item > .van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right {
  width: 100%;
  height: 100%;
}
.van-nav-bar {
  z-index: 99999;
}
.tabs {
  margin-top: 120px;
}

.van-icon {
  margin-right: 0.6rem;
  color: #4090fa;
}

.icon {
  margin-left: 1rem;
}
</style>
